/**
 * Set Microsoft Clarity custom user ID (e.g. email) for session identification.
 * Call once the user has finished entering their email on login, signup, or checkout.
 * @param {string} userId - Custom user id, typically the user's email
 */
export function setClarityUserId(userId) {
  if (!userId || typeof userId !== 'string') return;
  const trimmed = userId.trim();
  if (!trimmed) return;
  try {
    if (typeof window !== 'undefined' && window.clarity) {
      window.clarity('identify', trimmed);
    }
  } catch (_) {
    // Clarity may not be loaded; ignore
  }
}

/**
 * Set a Microsoft Clarity custom tag (e.g. purchases for conversion filtering).
 * @param {string} key - Tag name
 * @param {string|boolean} value - Tag value (boolean is sent as "true"/"false")
 */
export function setClarityTag(key, value) {
  if (!key || typeof key !== 'string') return;
  try {
    if (typeof window !== 'undefined' && window.clarity) {
      const str = typeof value === 'boolean' ? (value ? 'true' : 'false') : String(value);
      window.clarity('set', key, str);
    }
  } catch (_) {
    // Clarity may not be loaded; ignore
  }
}
